module.exports = __webpack_public_path__ + "img/CIO200_1-1.bb28b716.png";